import App_store_icon_sm from "@/assets/icons/app-icons/footer-app-store-icon-sm.svg?react";
import Google_play_icon_sm from "@/assets/icons/app-icons/footer-google-icon-sm.svg?react";
import App_store_icon_lg from "@/assets/icons/app-icons/footer-app-store-icon-lg.svg?react";
import Google_play_icon_lg from "@/assets/icons/app-icons/footer-google-icon-lg.svg?react";

import App_store_icon_download_sm from "@/assets/icons/downloadApp/app-store-sm.svg?react";
import Google_play_icon_download_sm from "@/assets/icons/downloadApp/google-play-sm.svg?react";
import App_store_icon_download_lg from "@/assets/icons/downloadApp/app-store-lg.svg?react";
import Google_play_icon_download_lg from "@/assets/icons/downloadApp/google-play-lg.svg?react";

/**
 * Returns an array of objects containing app icons based on the screen size.
 * @param type Type: 'footer' or 'downloadApp'
 * @param isLargeScreen A boolean indicating if the screen size is large.
 * @returns An array of objects containing app icons.
 */
export const getAppLinks = (
  isLargeScreen: boolean,
  type: "footer" | "download" = "footer"
) => {
  let appStoreIcon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  if (type === "footer") {
    appStoreIcon = isLargeScreen ? App_store_icon_lg : App_store_icon_sm;
  } else {
    appStoreIcon = isLargeScreen
      ? App_store_icon_download_lg
      : App_store_icon_download_sm;
  }

  let googlePlayIcon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  if (type === "footer") {
    googlePlayIcon = isLargeScreen ? Google_play_icon_lg : Google_play_icon_sm;
  } else {
    googlePlayIcon = isLargeScreen
      ? Google_play_icon_download_lg
      : Google_play_icon_download_sm;
  }

  return [
    {
      AppIcon: appStoreIcon,
      href: "https://apps.apple.com/us/app/trackmategps/id1109000685?platform=iphone",
    },
    {
      AppIcon: googlePlayIcon,
      href: "https://play.google.com/store/apps/details?id=com.fleetManagementServices.pinspot&hl=en&gl=US",
    },
  ];
};
